import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import { Link } from "react-router-dom";
import { FaComments } from "react-icons/fa";

import Modal from "./Modal";
import UserAvatar from "./UserAvatar";
import TransactionSellerContact from "./TransactionSellerContact";
import { formatPublicUserId } from "../utils/userPublicUtils";
import "./styles/ModalGodiwayer.css";
import * as actions_contact from "../redux/actions/contactsActions";

function getInitials(name, lastName) {
  const first = (name || "").charAt(0);
  const last = (lastName || "").charAt(0);
  return `${first}${last}`.toUpperCase();
}

function getPhoneLada(country) {
  if (!country) return "";
  return country.Lada || country.lada || "";
}

function formatPhone(phone, country) {
  if (!phone?.trim()) return "";
  const lada = getPhoneLada(country);
  return lada ? `(+${lada}) ${phone.trim()}` : phone.trim();
}

function ContactField({ label, value, href }) {
  const hasValue = Boolean(value?.trim());

  return (
    <div className="godiwayer-modal__field">
      <p className="godiwayer-modal__field-label">{label}</p>
      {hasValue ? (
        href ? (
          <a className="godiwayer-modal__field-link" href={href}>
            {value}
          </a>
        ) : (
          <p className="godiwayer-modal__field-value">{value}</p>
        )
      ) : (
        <p className="godiwayer-modal__field-value godiwayer-modal__field-empty">
          —
        </p>
      )}
    </div>
  );
}

class ModalGodiwayer extends React.Component {
  onClickChat = () => {
    this.props.SetContact(this.props.item);
    this.props.onClose();
  };

  render() {
    const {
      item,
      country,
      authCountry,
      showChatAction,
      sellerContact,
      identityOnly = false,
      isOpen,
      onClose,
    } = this.props;

    if (!item || (!item.Id && !item.UserId && !item.Username)) {
      return null;
    }

    const phoneCountry = country || authCountry;
    const fullName = `${item.Name || ""} ${item.LastN || ""}`.trim();
    const phone = formatPhone(item.Phone, phoneCountry);
    const email = item.Email?.trim() || "";
    const city = [item.City, item.State].filter(Boolean).join(", ");
    const about = item.AboutUs?.trim() || "";
    const username = item.Username ? `@${item.Username}` : "";
    const publicId =
      item.PublicId || formatPublicUserId(item.Id || item.UserId);
    const memberSince = item.MemberCreatedAt || "";

    return (
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={username || fullName || <Translate value="see_profile" />}
      >
        <div className="godiwayer-modal">
          <div className="godiwayer-modal__hero">
            <UserAvatar
              src={item.Avatar}
              alt=""
              verified={item.Verified}
              user={item}
              size="lg"
              imgClassName="godiwayer-modal__avatar"
              initials={getInitials(item.Name, item.LastN)}
            />
            {fullName && <h2 className="godiwayer-modal__name">{fullName}</h2>}
            {username && <p className="godiwayer-modal__username">{username}</p>}
          </div>

          {sellerContact && (
            <div className="godiwayer-modal__seller-contact">
              <TransactionSellerContact contact={sellerContact} />
            </div>
          )}

          <div className="godiwayer-modal__fields">
            <ContactField
              label={<Translate value="profile_member_since" />}
              value={memberSince}
            />
            <ContactField
              label={<Translate value="profile_public_id" />}
              value={publicId}
            />
            {!identityOnly && (
              <>
                <ContactField
                  label={<Translate value="profile_phone" />}
                  value={phone}
                  href={item.Phone ? `tel:${item.Phone.replace(/\s/g, "")}` : null}
                />
                <ContactField
                  label={<Translate value="profile_email" />}
                  value={email}
                  href={email ? `mailto:${email}` : null}
                />
                <ContactField
                  label={<Translate value="profile_city" />}
                  value={city}
                />
              </>
            )}
          </div>

          {!identityOnly && about && (
            <p className="godiwayer-modal__about">{about}</p>
          )}

          <div className="godiwayer-modal__footer">
            {!identityOnly && showChatAction && item.ConversationId && (
              <Link
                className="godiwayer-modal__btn godiwayer-modal__btn--chat"
                to={`/chat/${item.ConversationId}`}
                onClick={this.onClickChat}
              >
                <FaComments />
                <Translate value="chat_title" />
              </Link>
            )}
            <button
              type="button"
              className="godiwayer-modal__btn godiwayer-modal__btn--close"
              onClick={onClose}
            >
              <Translate value="ok" />
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

ModalGodiwayer.defaultProps = {
  showChatAction: true,
};

function mapStateToProps(state) {
  return {
    authCountry: state.session.auth?.country,
  };
}

const mapDispatchToProps = (dispatch) => ({
  SetContact: (item) => dispatch(actions_contact.setContact(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalGodiwayer);
